import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="85%" height="85%" viewBox="0 0 500.000000 500.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)" >
<path d="M2255 4873 c-478 -56 -836 -197 -1200 -469 -223 -167 -424 -388 -582
-639 -59 -94 -173 -310 -173 -328 0 -4 -11 -30 -24 -59 -49 -108 -102 -300
-137 -498 -31 -170 -34 -544 -6 -720 24 -147 76 -351 122 -476 81 -219 246
-514 380 -679 120 -147 281 -305 413 -404 354 -266 754 -426 1206 -482 125
-15 489 -6 601 15 210 39 422 97 530 146 166 74 222 101 306 151 211 124 315
204 484 374 152 151 201 210 301 360 206 305 332 632 390 1005 23 143 26 513
6 635 -24 143 -61 321 -82 386 -118 373 -321 715 -578 976 -171 174 -275 257
-477 380 -262 159 -621 283 -920 318 -117 13 -472 19 -560 8z m-758 -934 l38
-50 5 48 c5 43 8 48 33 51 l27 3 0 -100 0 -101 -30 0 c-23 0 -35 9 -62 48
l-33 47 -3 -47 c-3 -46 -5 -48 -33 -48 l-29 0 0 100 c0 100 0 100 25 100 18 0
35 -14 62 -51z m268 37 c40 -17 71 -71 62 -108 -4 -13 -16 -35 -27 -48 -18
-21 -32 -25 -96 -28 l-74 -4 0 94 c0 52 3 98 7 101 12 12 93 7 128 -7z m230 0
c63 -27 78 -106 29 -157 -23 -24 -36 -29 -77 -29 -64 0 -107 39 -107 97 1 44
15 66 56 88 36 19 56 19 99 1z m172 -35 c12 -24 24 -46 27 -48 3 -3 15 18 28
46 22 49 25 51 58 49 35 -3 35 -3 38 -58 2 -30 1 -74 -3 -97 -5 -37 -10 -43
-31 -43 -21 0 -24 5 -24 34 0 42 -15 55 -24 21 -3 -13 -16 -30 -28 -36 -18
-10 -24 -8 -35 7 -8 11 -16 29 -20 42 -9 38 -23 24 -23 -23 0 -41 -2 -45 -25
-45 l-25 0 0 101 0 100 33 -3 c27 -2 36 -10 54 -47z m318 22 c3 -15 22 -60 40
-100 l34 -73 -40 0 c-28 0 -39 4 -39 15 0 11 -11 15 -40 15 -29 0 -40 -4 -40
-15 0 -10 -11 -15 -35 -15 -19 0 -35 2 -35 4 0 2 14 36 31 77 17 41 35 84 40
97 6 17 17 22 43 22 29 0 35 -4 41 -27z m277 17 c35 -10 37 -12 26 -36 -8 -17
-17 -23 -30 -19 -10 3 -28 8 -39 11 -36 10 -17 -18 20 -31 18 -6 39 -19 46
-28 17 -23 7 -65 -18 -78 -24 -13 -123 -7 -138 8 -17 17 -1 56 19 48 10 -4 29
-11 45 -15 44 -14 34 16 -10 31 -44 14 -53 24 -53 61 0 20 8 32 28 42 32 18
55 19 104 6z m118 -60 c0 -56 3 -72 16 -77 27 -10 44 25 44 89 0 58 0 58 30
58 l30 0 0 -74 c0 -92 -21 -126 -78 -126 -57 0 -77 9 -95 40 -17 28 -24 139
-10 153 3 4 19 7 35 7 l28 0 0 -70z m305 50 c18 -15 20 -51 4 -67 -9 -9 -7
-16 5 -29 23 -22 16 -56 -14 -71 -14 -7 -55 -13 -91 -13 l-65 0 -3 90 c-1 49
1 95 5 101 9 15 138 6 159 -11z m625 -156 c175 -51 304 -179 349 -345 8 -28
12 -86 9 -145 -4 -123 -31 -187 -111 -267 -78 -76 -224 -146 -243 -115 -5 7
-8 65 -9 128 0 138 -24 218 -90 302 -139 178 -431 177 -613 0 -63 -61 -105
-122 -168 -240 -59 -111 -163 -378 -225 -577 -53 -175 -208 -658 -269 -845
-16 -47 -38 -119 -50 -160 -12 -41 -27 -81 -32 -87 -17 -21 -48 -15 -58 11 -5
13 -59 226 -119 472 -61 247 -120 483 -131 524 -11 41 -40 153 -64 248 -40
162 -57 202 -64 156 -2 -10 -19 -75 -38 -144 -19 -69 -48 -175 -64 -237 -59
-225 -181 -609 -226 -711 -63 -143 -178 -284 -269 -329 -88 -44 -140 -55 -253
-51 -98 3 -114 6 -174 36 -83 41 -156 118 -186 197 -46 119 -22 303 53 415 68
101 161 180 213 180 30 0 34 -13 17 -62 -56 -161 51 -300 219 -286 62 5 165
52 220 99 133 116 244 346 349 724 86 307 86 483 3 650 -70 138 -174 218 -348
265 -53 14 -71 30 -62 54 6 15 47 16 457 14 l451 -3 8 -30 c8 -32 149 -607
224 -915 24 -102 44 -190 44 -197 0 -6 5 -24 11 -39 11 -31 2 -53 118 301 128
393 206 558 348 742 124 159 246 239 428 279 77 17 270 10 345 -12z m-539
-525 c-31 -123 16 -261 128 -369 46 -44 145 -129 174 -149 12 -8 24 -18 27
-21 3 -3 43 -35 90 -70 208 -159 286 -234 361 -348 79 -121 92 -166 93 -317 0
-110 -3 -140 -22 -193 -83 -234 -281 -376 -541 -389 -168 -9 -246 8 -559 121
-133 47 -230 28 -316 -63 -51 -54 -85 -29 -57 41 5 13 26 77 46 143 45 148 81
267 139 455 25 80 57 187 73 237 39 131 67 137 84 17 9 -66 15 -99 40 -216 67
-321 198 -544 364 -624 53 -25 71 -29 155 -29 105 0 134 10 194 69 94 91 80
299 -28 430 -43 53 -124 133 -171 171 -84 66 -100 80 -103 88 -2 4 -8 7 -14 7
-5 0 -15 6 -22 13 -7 6 -42 37 -77 67 -124 108 -187 187 -233 295 -26 62 -30
84 -34 196 -5 136 5 180 65 306 40 81 160 191 144 132z"/>
<path d="M1699 3913 c-5 -67 -4 -68 20 -68 30 0 46 24 37 58 -5 20 -13 27 -31
27 -17 0 -25 -6 -26 -17z"/>
<path d="M1911 3908 c-12 -30 9 -63 40 -63 30 0 49 45 29 69 -19 24 -59 20
-69 -6z"/>
<path d="M2430 3901 c0 -5 -3 -16 -6 -25 -4 -12 0 -16 16 -16 16 0 20 4 16 16
-3 9 -6 20 -6 25 0 5 -4 9 -10 9 -5 0 -10 -4 -10 -9z"/>
<path d="M3090 3925 c0 -11 7 -15 23 -13 12 2 22 8 22 13 0 6 -10 11 -22 13
-16 2 -23 -2 -23 -13z"/>
<path d="M3090 3856 c0 -11 9 -16 26 -16 31 0 28 23 -4 28 -15 2 -22 -2 -22
-12z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
